export default __webpack_public_path__ + "static/media/58.77e6d490.jpg";